import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
export default class Turnstile extends Component {
  form = null;
  oncreate(vnode) {
    super.oncreate(vnode);
    const theme = this.detectTheme();
    this.form = vnode.dom.closest('form');
    this.form?.addEventListener('input', this.cancelHeldSubmit);
    this.attrs.state.render(vnode.dom.querySelector('.cf-turnstile'), theme);
  }
  onremove(vnode) {
    this.form?.removeEventListener('input', this.cancelHeldSubmit);
    this.attrs.state.remove();
    super.onremove(vnode);
  }

  // Editing changes what a held submission would send, so let the visitor submit again when ready.
  cancelHeldSubmit = () => {
    if (this.attrs.state.cancelSubmit()) m.redraw();
  };
  detectTheme() {
    const currentTheme = document.documentElement.dataset.theme || 'light';
    return currentTheme.startsWith('dark') ? 'dark' : 'light';
  }
  view() {
    const {
      message
    } = this.attrs.state;
    return m("div", {
      className: "Form-group"
    }, m("div", {
      className: "cf-turnstile"
    }), m("div", {
      className: "visually-hidden",
      role: "status"
    }, message && app.translator.trans(message)));
  }
}
flarum.reg.add('flectar-turnstile', 'forum/components/Turnstile', Turnstile);